<div class="iana-staff-header" [ngClass]="{'test-server': env === 'QA' || env === 'UAT' || env === 'OTE'}">
  <div class="grid-container header-bar-section">
    <div class="header-section">
      <a [href]="homeRoute">
        <img src="assets/images/logo.svg" alt="IANA logo">
      </a>
      <a [href]="homeRoute" class="root-zone-header">Root Zone Management</a>
      <ng-container *ngIf="env === 'QA' || env === 'UAT' || env === 'OTE'">
        <div class="dev-label">Non-Production ({{env}})</div>
      </ng-container>
    </div>
    <div>
      <navigation-bar *ngIf="showNavigation()" (navigateToSettings)="navigateBackToSettings()" ></navigation-bar>
    </div>
  </div>

</div>
